// @ts-nocheck
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
import * as Types from "../../__generated__/schema.graphql.types";

const defaultOptions = {} as const;
export type WalletQueryVariables = Types.Exact<{
  clientId: Types.Scalars["bigint"]["input"];
}>;

export type WalletQuery = {
  __typename?: "query_root";
  clientByPk?: {
    __typename?: "client";
    id: string;
    clientMemberships: Array<{
      __typename?: "ClientMembership";
      id: string;
      status: string;
    }>;
    stripeData?: {
      __typename?: "ClientStripeType";
      id: string;
      stripeCardsList: Array<{
        __typename?: "MoxieCardType";
        id?: string | null;
        brand?: string | null;
        country?: string | null;
        expMonth?: number | null;
        expYear?: number | null;
        funding?: string | null;
        last4?: string | null;
        isDefault?: boolean | null;
      } | null>;
    } | null;
    wallet?: {
      __typename?: "ClientWalletType";
      currentSums: {
        __typename?: "WalletSumsType";
        credits: Array<{
          __typename?: "CreditSumType";
          creditType: string;
          sum: string;
        } | null>;
        services: Array<{
          __typename?: "ServiceSumType";
          serviceId: string;
          sum: string;
        } | null>;
        products: Array<{
          __typename?: "ProductSumType";
          productId: string;
          sum: string;
        } | null>;
        serviceProducts: Array<{
          __typename?: "ServiceProductSumType";
          serviceProductId: string;
          sum: string;
        } | null>;
      };
    } | null;
  } | null;
};

export type WalletBalanceSnapshotQueryVariables = Types.Exact<{
  clientId: Types.Scalars["bigint"]["input"];
}>;

export type WalletBalanceSnapshotQuery = {
  __typename?: "query_root";
  clientByPk?: {
    __typename?: "client";
    id: string;
    walletBalanceSnapshot: JSONb;
    walletSnapshotCreatedAt?: string | null;
  } | null;
};

export type WalletCreditsQueryVariables = Types.Exact<{
  clientId: Types.Scalars["bigint"]["input"];
}>;

export type WalletCreditsQuery = {
  __typename?: "query_root";
  clientByPk?: {
    __typename?: "client";
    id: string;
    wallet?: {
      __typename?: "ClientWalletType";
      currentSums: {
        __typename?: "WalletSumsType";
        credits: Array<{
          __typename?: "CreditSumType";
          creditType: string;
          sum: string;
        } | null>;
      };
    } | null;
  } | null;
};

export const WalletDocument = gql`
  query Wallet($clientId: bigint!) {
    clientByPk(id: $clientId) {
      id
      clientMemberships {
        id
        status
      }
      stripeData {
        id
        stripeCardsList {
          id
          brand
          country
          expMonth
          expYear
          funding
          last4
          isDefault
        }
      }
      wallet {
        currentSums {
          credits {
            creditType
            sum
          }
          services {
            serviceId
            sum
          }
          products {
            productId
            sum
          }
          serviceProducts {
            serviceProductId
            sum
          }
        }
      }
    }
  }
`;

/**
 * __useWalletQuery__
 *
 * To run a query within a React component, call `useWalletQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useWalletQuery(
  baseOptions: Apollo.QueryHookOptions<WalletQuery, WalletQueryVariables> &
    ({ variables: WalletQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WalletQuery, WalletQueryVariables>(
    WalletDocument,
    options
  );
}
export function useWalletLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<WalletQuery, WalletQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WalletQuery, WalletQueryVariables>(
    WalletDocument,
    options
  );
}
export function useWalletSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<WalletQuery, WalletQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<WalletQuery, WalletQueryVariables>(
    WalletDocument,
    options
  );
}
export type WalletQueryHookResult = ReturnType<typeof useWalletQuery>;
export type WalletLazyQueryHookResult = ReturnType<typeof useWalletLazyQuery>;
export type WalletSuspenseQueryHookResult = ReturnType<
  typeof useWalletSuspenseQuery
>;
export type WalletQueryResult = Apollo.QueryResult<
  WalletQuery,
  WalletQueryVariables
>;
export const WalletBalanceSnapshotDocument = gql`
  query WalletBalanceSnapshot($clientId: bigint!) {
    clientByPk(id: $clientId) {
      id
      walletBalanceSnapshot
      walletSnapshotCreatedAt
    }
  }
`;

/**
 * __useWalletBalanceSnapshotQuery__
 *
 * To run a query within a React component, call `useWalletBalanceSnapshotQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletBalanceSnapshotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletBalanceSnapshotQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useWalletBalanceSnapshotQuery(
  baseOptions: Apollo.QueryHookOptions<
    WalletBalanceSnapshotQuery,
    WalletBalanceSnapshotQueryVariables
  > &
    (
      | { variables: WalletBalanceSnapshotQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WalletBalanceSnapshotQuery,
    WalletBalanceSnapshotQueryVariables
  >(WalletBalanceSnapshotDocument, options);
}
export function useWalletBalanceSnapshotLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WalletBalanceSnapshotQuery,
    WalletBalanceSnapshotQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WalletBalanceSnapshotQuery,
    WalletBalanceSnapshotQueryVariables
  >(WalletBalanceSnapshotDocument, options);
}
export function useWalletBalanceSnapshotSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WalletBalanceSnapshotQuery,
        WalletBalanceSnapshotQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WalletBalanceSnapshotQuery,
    WalletBalanceSnapshotQueryVariables
  >(WalletBalanceSnapshotDocument, options);
}
export type WalletBalanceSnapshotQueryHookResult = ReturnType<
  typeof useWalletBalanceSnapshotQuery
>;
export type WalletBalanceSnapshotLazyQueryHookResult = ReturnType<
  typeof useWalletBalanceSnapshotLazyQuery
>;
export type WalletBalanceSnapshotSuspenseQueryHookResult = ReturnType<
  typeof useWalletBalanceSnapshotSuspenseQuery
>;
export type WalletBalanceSnapshotQueryResult = Apollo.QueryResult<
  WalletBalanceSnapshotQuery,
  WalletBalanceSnapshotQueryVariables
>;
export const WalletCreditsDocument = gql`
  query WalletCredits($clientId: bigint!) {
    clientByPk(id: $clientId) {
      id
      wallet {
        currentSums {
          credits {
            creditType
            sum
          }
        }
      }
    }
  }
`;

/**
 * __useWalletCreditsQuery__
 *
 * To run a query within a React component, call `useWalletCreditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletCreditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletCreditsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useWalletCreditsQuery(
  baseOptions: Apollo.QueryHookOptions<
    WalletCreditsQuery,
    WalletCreditsQueryVariables
  > &
    (
      | { variables: WalletCreditsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WalletCreditsQuery, WalletCreditsQueryVariables>(
    WalletCreditsDocument,
    options
  );
}
export function useWalletCreditsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WalletCreditsQuery,
    WalletCreditsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WalletCreditsQuery, WalletCreditsQueryVariables>(
    WalletCreditsDocument,
    options
  );
}
export function useWalletCreditsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WalletCreditsQuery,
        WalletCreditsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WalletCreditsQuery,
    WalletCreditsQueryVariables
  >(WalletCreditsDocument, options);
}
export type WalletCreditsQueryHookResult = ReturnType<
  typeof useWalletCreditsQuery
>;
export type WalletCreditsLazyQueryHookResult = ReturnType<
  typeof useWalletCreditsLazyQuery
>;
export type WalletCreditsSuspenseQueryHookResult = ReturnType<
  typeof useWalletCreditsSuspenseQuery
>;
export type WalletCreditsQueryResult = Apollo.QueryResult<
  WalletCreditsQuery,
  WalletCreditsQueryVariables
>;
